export class CreateAccountMessage {
  dateOfBirth: string
  email: string
  firstName: string
  lastName: string
  password: string
  
  constructor(dateOfBirth: string, email: string, firstName: string, lastName: string, password: string) {
    this.dateOfBirth = dateOfBirth
    this.email = email
    this.firstName = firstName
    this.lastName = lastName
    this.password = password
  }
}
    